module.exports = __webpack_public_path__ + "static/media/dublin-bus.3786d3bc.png";